import React from 'react'
import { Toaster } from 'react-hot-toast';

export default function Toasts() {
    return (
        <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={12}
            containerClassName=""
            containerStyle={{ zIndex: 9999 }} // Ensures it's on top of most elements
            toastOptions={{
                className: '',
                duration: 5000,
                removeDelay: 3000,
                style: {
                    background: '#1e293b', // Tailwind slate-800-like dark background
                    color: '#fff',
                    padding: '16px 24px',
                    fontSize: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                },
                success: {
                    duration: 3000,
                    iconTheme: {
                        primary: '#22c55e', // Tailwind green-500
                        secondary: '#ffffff',
                    },
                },
                error: {
                    duration: 4000,
                    iconTheme: {
                        primary: '#ef4444', // Tailwind red-500
                        secondary: '#ffffff',
                    },
                },
            }}
        />
    )
}
